import script from "./msgDefault.vue?vue&type=script&setup=true&name=msgDefault&lang=js"
export * from "./msgDefault.vue?vue&type=script&setup=true&name=msgDefault&lang=js"

import "./msgDefault.vue?vue&type=style&index=0&id=008f9cc6&scoped=true&lang=css"

import exportComponent from "/Users/nasinet/hujing_pro/hj_pro_h5/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-008f9cc6"]])

export default __exports__